import React from 'react'
import { useRouter } from 'next/router'

import TryNow from 'components/common/sections/TryNow/TryNow'
import { RouteEnum } from '../../../enums/RouteEnum'

import styles from './TryWrap.module.scss'

const TryWrap: React.FC = () => {
  const router = useRouter()

  const handleClick = () => {
    router.push(`${RouteEnum.SIGNUP}/?from=${router.pathname}`)
  }

  return (
    <div className={styles.tryWrapper}>
      <TryNow
        toolName={''}
        description="Start using the full version of Bishopi’s Domain Trends today!"
        title={'Try Bishopi Now'}
        ctaText="Sign up for Bishopi"
        onClickCta={handleClick}
      />
    </div>
  )
}

export default TryWrap
